export default "__VITE_ASSET__fb55cb4e__"